import {
  resolveSearchHitIsTyomarkkinatori,
  TYOMARKKINATORI_LOGO_PATH,
} from './resolve-search-hit-is-tyomarkkinatori';

/**
 * Align Työmarkkinatori search hits with Algolia/maintainer rules (flags + employer display).
 */
export function applyTyomarkkinatoriSearchHitParity(hit: Record<string, unknown>): void {
  if (!resolveSearchHitIsTyomarkkinatori(hit)) {
    return;
  }

  hit.isTyomarkkinatori = true;
  hit.isFinland = true;

  const existingLogoUrl = typeof hit.logoUrl === 'string' ? hit.logoUrl.trim() : '';
  if (!existingLogoUrl) {
    hit.logoUrl = TYOMARKKINATORI_LOGO_PATH;
  }

  const companyId = typeof hit.companyId === 'string' ? hit.companyId.trim() : '';
  if (companyId && !hit.companyName) {
    hit.companyName = companyId;
  }
}
